import { DSCardWrapper } from "@components/design-system/molecules";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const MessageDisplay = ({ error, success }) => {
  if (!error && !success) return null;

  return (
    <>
      {error && (
        <DSCardWrapper variant="danger">
          <div className="flex items-center">
            <FontAwesomeIcon
              icon={faTimes}
              className="text-danger mr-2"
            />
            <p className="text-danger text-sm">{error}</p>
          </div>
        </DSCardWrapper>
      )}

      {success && (
        <DSCardWrapper variant="success">
          <div className="flex items-center">
            <FontAwesomeIcon
              icon={faCheck}
              className="text-success mr-2"
            />
            <p className="text-success text-sm">{success}</p>
          </div>
        </DSCardWrapper>
      )}
    </>
  );
};

export default MessageDisplay;
